module.exports = __webpack_public_path__ + "img/info.ac383d67.svg";